var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicRopa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C7D2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clothesGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#312E81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "embroideryGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F43F5E"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(49, 46, 129, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -16,-12 L -6,-16 L 0,-10 L 6,-16 L 16,-12 L 20,8 L -20,8 Z",
    fill: "url(#clothesGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6,-16 L 0,-6 L 6,-16",
    fill: "none",
    stroke: "url(#embroideryGrad)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 2,
    width: 40,
    height: 6,
    fill: "url(#embroideryGrad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -18,2 L -18,8 M -14,2 L -14,8 M -10,2 L -10,8 M -6,2 L -6,8 M -2,2 L -2,8 M 2,2 L 2,8 M 6,2 L 6,8 M 10,2 L 10,8 M 14,2 L 14,8 M 18,2 L 18,8",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2.5,
    fill: "#FBBF24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -4,
    cy: 0,
    r: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 0,
    r: 1.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -4,
    r: 1.5,
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicRopa);
export default __webpack_public_path__ + "static/media/topic_ropa.2c471138f2c9b76924dab0a6328bb184.svg";
export { ForwardRef as ReactComponent };